import axios from 'axios'
import { getAPIUrl } from '../API'

export interface ProvinceOrMetropolitan {
  provinceName: string
  code: string
  category: string
  name: string
}

export const getMetropolitansAndProvinces: () => Promise<
  ProvinceOrMetropolitan[]
> = async () => {
  const { data } = await axios.get(
    `${getAPIUrl()}/Common/metropolitanareaandprovinces`,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return data.data
}
